import React from 'react'
import { Link } from 'react-router-dom'

import {
  AlignBottom0213,
  Award0313,
  BarChartSquare0113,
  CodeCircle0313,
  Grid0113,
  Image0113,
  ImageIndentLeft13,
  Tag0113,
  Trophy0113,
  UsersPlus13,
  UserSquare13,
  Wallet0213,
} from '@affstore-ds/icons'
import { NavMenuLinkInterface } from '@affstore-ds/uikit'
import { DateTime } from 'luxon'

import { featuresStatuses } from '../../config/brands'
import { routes } from '../routes'
import { navMenuTranslationKeys } from '../translations/NavMenu.translationKeys'
import { navMenuItemDataTestIds } from './navMenuDataTestIds'

export const profileTabSettings = {
  contactInfo: 'contact-info',
  personal: 'personal',
}

export const profileTabSettingsPersonal = routes.ROUTES_PROFILE.profileSettingsTab.replace(':tabValue', profileTabSettings.personal)

const offerRulesTabSettings = {
  ruleAppsGuidelines: 'rules-apps-guidelines',
  ruleMarketingGuidelines: 'rules-marketing-guidelines',
  ruleNegativeKeywords: 'rules-negative-keywords',
  rulePaymentTerms: 'rules-payment-terms',
  ruleRestriction: 'rules-general-restrictions',
  ruleTrafficTypes: 'rules-traffic-types',
}

export const offerTabSettings = {
  activation: 'activation',
  advertiser: 'advertiser',
  backlink: 'backlink',
  links: 'links',
  rates: 'rates',
  rules: offerRulesTabSettings,
}

export const paymentsTabSettings = {
  history: 'history',
  regularAndRequests: 'regular-and-requests',
  settings: 'settings',
}

export const paymentsTabSettingsRegularAndRequests = routes.ROUTES_PAYMENTS.paymentsTab.replace(':tabValue', paymentsTabSettings.regularAndRequests)

export const promoTabSettings = {
  videos: 'videos',
  backlinks: 'backlinks',
  banners: 'banners',
  landings: 'landings',
}

export const promoTabSettingsLandings = routes.ROUTES_PROMO.promoTab.replace(':tabValue', promoTabSettings.landings)

// TODO: update this date to the current date when the dashboard page is updated and ready for release
export const displayNewBadgeUpToDateForDashboardPage = DateTime.fromObject({ day: 26, month: 8, year: 2026 }).plus({ day: 45 }).toMillis()

export const NAV_MENU_DATA: NavMenuLinkInterface[] = [
  ...(featuresStatuses.isDashboardPageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemDashboard,
          component: Link,
          counter: displayNewBadgeUpToDateForDashboardPage,
          dataTestId: navMenuItemDataTestIds.dashboard,
          icon: <Grid0113 strokeWidth={1.6} />,
          value: routes.ROUTES_DASHBOARD.root,
        },
      ]
    : []),
  ...(featuresStatuses.isLoyaltyProgramPageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemLoyaltyProgram,
          component: Link,
          dataTestId: navMenuItemDataTestIds.loyaltyProgram,
          icon: <Award0313 strokeWidth={1.6} />,
          value: routes.ROUTES_LOYALTY_PROGRAM.root,
        },
      ]
    : []),
  {
    label: navMenuTranslationKeys.navMenuItemStatistics,
    children: [
      {
        label: navMenuTranslationKeys.navMenuItemStatisticsGeneral,
        component: Link,
        dataTestId: navMenuItemDataTestIds.statisticsGeneral,
        depthCheck: 2,
        value: routes.ROUTES_STATISTICS.general,
      },
      {
        label: navMenuTranslationKeys.navMenuItemStatisticsUsers,
        component: Link,
        dataTestId: navMenuItemDataTestIds.statisticsByUsers,
        depthCheck: 2,
        value: routes.ROUTES_STATISTICS.users,
      },
    ],
    component: 'button',
    dataTestId: navMenuItemDataTestIds.statistics,
    icon: <BarChartSquare0113 strokeWidth={1.6} />,
    value: routes.ROUTES_STATISTICS.root,
  },
  ...(featuresStatuses.isNewOffersPageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemOffers,
          children: [
            {
              label: navMenuTranslationKeys.navMenuItemOffersByAdvertisers,
              component: Link,
              dataTestId: navMenuItemDataTestIds.offersByAdvertisers,
              depthCheck: 2,
              value: routes.ROUTES_OFFERS.offersAdvertisers,
            },
            {
              label: navMenuTranslationKeys.navMenuItemOffersByOffers,
              component: Link,
              dataTestId: navMenuItemDataTestIds.offersByOffers,
              depthCheck: 2,
              value: routes.ROUTES_OFFERS.offers,
            },
          ],
          component: 'button',
          dataTestId: navMenuItemDataTestIds.offers,
          icon: <Tag0113 strokeWidth={1.6} />,
          value: routes.ROUTES_OFFERS.offers,
        },
      ]
    : [
        {
          label: navMenuTranslationKeys.navMenuItemOffers,
          component: Link,
          dataTestId: navMenuItemDataTestIds.offers,
          icon: <Tag0113 strokeWidth={1.6} />,
          value: routes.ROUTES_OFFERS.offers,
        },
      ]),
  ...(featuresStatuses.isPromoPageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemPromo,
          component: Link,
          dataTestId: navMenuItemDataTestIds.promo,
          icon: <Image0113 strokeWidth={1.6} />,
          value: promoTabSettingsLandings,
        },
      ]
    : []),
  {
    label: navMenuTranslationKeys.navMenuItemPayments,
    component: Link,
    dataTestId: navMenuItemDataTestIds.payments,
    icon: <Wallet0213 strokeWidth={1.6} />,
    value: paymentsTabSettingsRegularAndRequests,
  },
  ...(featuresStatuses.isTop10PageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemTop,
          component: Link,
          dataTestId: navMenuItemDataTestIds.top,
          icon: <Trophy0113 strokeWidth={1.6} />,
          value: routes.ROUTES_TOP.root,
        },
      ]
    : []),
  ...(featuresStatuses.isContestsPageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemContests,
          component: Link,
          dataTestId: navMenuItemDataTestIds.contests,
          icon: <AlignBottom0213 strokeWidth={1.6} />,
          value: routes.ROUTES_CONTESTS.tabsPath.replace(routes.ROUTES_CONTESTS_TABS._paramsKey, routes.ROUTES_CONTESTS_TABS.active),
        },
      ]
    : []),
  ...(featuresStatuses.isBlogLinkEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemBlog,
          component: 'a',
          dataTestId: navMenuItemDataTestIds.blog,
          external: true,
          icon: <ImageIndentLeft13 strokeWidth={1.6} />,
          value: routes.ROUTES_INFO.blog,
        },
      ]
    : []),
  ...(featuresStatuses.isSubAffiliatePageEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemSubAffiliate,
          component: Link,
          dataTestId: navMenuItemDataTestIds.subAffiliate,
          depthCheck: 2,
          icon: <UsersPlus13 strokeWidth={1.6} />,
          value: routes.ROUTES_SUB_AFFILIATE.subAffiliate,
        },
      ]
    : []),
  ...(featuresStatuses.isTelegramPostbacksEnabled
    ? [
        {
          label: navMenuTranslationKeys.navMenuItemPostbacks,
          children: [
            {
              label: navMenuTranslationKeys.navMenuItemPostbacksGeneral,
              component: Link,
              dataTestId: navMenuItemDataTestIds.postbacksGeneral,
              depthCheck: 2,
              value: routes.ROUTES_POSTBACKS.postbacksList,
            },
            {
              label: navMenuTranslationKeys.navMenuItemPostbacksTelegram,
              component: Link,
              dataTestId: navMenuItemDataTestIds.postbacksTelegram,
              depthCheck: 2,
              value: routes.ROUTES_POSTBACKS.postbacksTelegram,
            },
          ],
          component: 'button',
          dataTestId: navMenuItemDataTestIds.postbacks,
          icon: <CodeCircle0313 strokeWidth={1.6} />,
          value: routes.ROUTES_POSTBACKS.postbacksAll,
        },
      ]
    : [
        {
          label: navMenuTranslationKeys.navMenuItemPostbacks,
          component: Link,
          dataTestId: navMenuItemDataTestIds.postbacks,
          icon: <CodeCircle0313 strokeWidth={1.6} />,
          value: routes.ROUTES_POSTBACKS.postbacksList,
        },
      ]),
  {
    label: navMenuTranslationKeys.navMenuItemProfile,
    children: [
      ...(featuresStatuses.isKYCEnabled
        ? [
            {
              label: navMenuTranslationKeys.navMenuItemProfileKyc,
              component: Link,
              dataTestId: navMenuItemDataTestIds.profileKyc,
              depthCheck: 2,
              value: routes.ROUTES_PROFILE.profileKYC,
            },
          ]
        : []),
      {
        label: navMenuTranslationKeys.navMenuItemProfileSecurity,
        component: Link,
        dataTestId: navMenuItemDataTestIds.profileSecurity,
        depthCheck: 2,
        value: routes.ROUTES_PROFILE.profileSecurity,
      },
      {
        label: navMenuTranslationKeys.navMenuItemProfileSettings,
        component: Link,
        dataTestId: navMenuItemDataTestIds.profileSettings,
        depthCheck: 2,
        value: profileTabSettingsPersonal,
      },
    ],
    component: 'button',
    dataTestId: navMenuItemDataTestIds.profile,
    icon: <UserSquare13 strokeWidth={1.6} />,
    value: routes.ROUTES_PROFILE.profile,
  },
]
